import ArrayUtil from './ArrayUtil';

export const getRespondentsFromCS = (csList) => {
  const resList = [];
  if (ArrayUtil.isNotEmpty(csList)) {
    csList.forEach((cs) => {
      const existed = resList.find(res => res.id === cs.respondent.id);
      if (!existed) {
        resList.push(cs.respondent);
      }
    });
  }
  return resList;
};

export const getRespondentsFromJPS = (jpsList) => {
  const resList = [];
  if (ArrayUtil.isNotEmpty(jpsList)) {
    jpsList.forEach((jps) => {
      const existed = resList.find(res => res.id === jps.respondent.id);
      if (!existed) {
        resList.push(jps.respondent);
      }
    });
  }
  return resList;
};
